
  <div style="margin: 10px; padding: 2em;">
    <div class="row" *ngIf="statuslimpio" style="background-color: lightgray;">
      <div class="col">
        <p>1. Seleccione un rango de fechas</p>
        <app-rangodefechas></app-rangodefechas>
      </div>
      <div class="col">
        <p>2. Seleccione cuenca</p>
        <div class="form-group">
          <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="cuenca" (ngModelChange)="cargaLocaciones($event)">
           
            <option>VMM</option>
            <option>VMM-otros</option>
            <option>VMM - SR & TSQ</option>
            <option>VMM-total</option>
            <option>Putumayo norte</option>
            <option>Putumayo sur</option>
            <option>Putumayo-total</option>
            <option>Bogota</option>
            <option>Ecuador-total</option>
            <option>Charapa</option>
            <option>Chanangue</option>
            <option>Iguana</option>
            <option>Perico</option>
          </select>
        </div>
      </div>
      <div class="col" *ngIf="cuenca != 'VMM-total' && cuenca != 'Putumayo-total' && cuenca != 'Ecuador-total'">
        <p>3. Seleccione locación</p>
        <div class="form-group" *ngIf="todalacuenca == false">
          <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="locacion" (ngModelChange)="seleccionaLocacion($event)" >
            <option *ngFor="let item of arraydelocaciones">{{item.data().name}}</option>
          </select>
        </div>

        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="exampleCheck1" [(ngModel)]="todalacuenca" (ngModelChange)="seleccionatodalacuenca($event)">
          <label class="form-check-label" for="exampleCheck1">Toda la cuenca</label>
        </div>

      </div>
      <div class="col">
        <p>4. Haga click en el botón para generar el reporte</p>
        <button *ngIf="statuslimpio" class="btn-warning  btn-block" (click)="generarReporte()">Generar reporte</button>
        
      </div>
    </div>

    <div class="row" *ngIf="! statuslimpio">
      <div class="col">
        <p><small><strong>Desde:</strong> {{servicioFechasQueryService.fechaquerymin}}</small></p>
        <p><small><strong>Hasta:</strong> {{servicioFechasQueryService.fechaquerymax}}</small></p>
      </div>
      <div class="col">
        <p><small><strong>Cuenca:</strong> {{cuenca}}</small></p>
        <p><small *ngIf="! todalacuenca"><strong>Locación:</strong> {{locacion}}</small></p>
        <p><small *ngIf="todalacuenca"><strong>Toda la cuenca</strong></small></p>
      </div>
      <div class="col">
        <button  class="btn-default  btn-block" (click)="nuevoReporte()">Nuevo reporte</button>
      </div>
    </div>
    <div *ngIf="alertaActiva">
      <ngb-alert #selfClosingAlert  type="warning" >
         <div class="spinner-border" role="status">
           <span class="sr-only"></span>
         </div>
         Cargando data...
       </ngb-alert>
    </div>
      <hr>
      <div class="row">
        <div class="col" style="text-align: center;">
          <p><strong>PTW por unidad de negocio</strong></p>
          
          <!-- <div class="row">

            <div class="col">
              <div class="pie-chart-container">
                <ngx-charts-advanced-pie-chart
                  
                  [scheme]="colorScheme"
                  [results]="dataChart2"
                  [gradient]="gradient"
                  (select)="onSelect($event)"
                  (activate)="onActivate($event)"
                  (deactivate)="onDeactivate($event)"
                ></ngx-charts-advanced-pie-chart>
              </div>
            </div>
          </div> -->
          <ngx-charts-pie-chart
            [view]="viewPie"
            [scheme]="colorScheme"
            [results]="dataChart2"
            [gradient]="gradientPie"
            [legend]="showLegendPie"
            [legendPosition]="legendPositionPie"
            [labels]="showLabelsPie"
            [trimLabels]="trimLabelsPie" 
            [doughnut]="isDoughnutPie"
            (select)="onSelectBox($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)"
            >
          </ngx-charts-pie-chart>
        </div>
        <div class="col">
          <div>
            <ngx-charts-number-card
              [view]="viewBox"
              [scheme]="colorScheme"
              [results]="dataChart2"
              [cardColor]="cardColor"
              (select)="onSelectBox($event)">
            </ngx-charts-number-card>
            
          </div>
        </div>
      </div>
      <hr>
          
          <div class="row" >
            <div class="col" style="text-align: center;">
              <p><strong>Trabajadores por empresa en unidad de negocio seleccionada</strong></p>
                  <ngx-charts-bar-horizontal
                  [scheme]="colorScheme"
                  [results]="dataDetalleUnidadDeNegocio"
                  [xAxis]="showXAxis"
                  [yAxis]="showYAxis"
                  [legend]="showLegend"
                  [showXAxisLabel]="showXAxisLabel"
                  [showYAxisLabel]="showYAxisLabel"
                  [xAxisLabel]="xAxisLabelUnidadNegocio"
                  [yAxisLabel]="yAxisLabelUnidadNegocio"
                  (select)="onSelect($event)"
                  (activate)="onActivate($event)"
                  (deactivate)="onDeactivate($event)">
                </ngx-charts-bar-horizontal>
                
            </div>
          </div>
      <hr>  
      <hr>
    <div class="row">
      <div class="col">
            <ngx-charts-bar-horizontal
            [scheme]="colorScheme"
            [results]="dataChart1"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [legend]="showLegend"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxisLabel]="xAxisLabel"
            [yAxisLabel]="yAxisLabel"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)">
          </ngx-charts-bar-horizontal>
      </div>
    </div>
    <hr>
    
    <hr>

    <div class="row">
      <div class="col" style="text-align: center;"> 
          <p><strong>PTW por tipo de tareas</strong></p>
          <p><small> ** - No incluye otros tipos de tareas - **</small></p>

            <ngx-charts-bar-vertical
            [scheme]="colorScheme"
            [results]="datachart3"
            [gradient]="gradient"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [legend]="showLegend"
            [showXAxisLabel]="showXAxisLabelBarrasVert"
            [showYAxisLabel]="showYAxisLabelBarrasVert"
            [xAxisLabel]="xAxisLabelBarrasVert"
            [yAxisLabel]="yAxisLabelBarrasVert"
            [barPadding]="5"
            (select)="onSelect($event)"
          >
          </ngx-charts-bar-vertical>
      </div>
    </div>
    
    <hr>
    <hr>

    <!-- <div class="row">
      <div class="col" style="text-align: center;"> 
        <p><strong>Trabajos ejecutados por tipo de tarea</strong></p>
        <p><small> ** - No incluye otros tipos de tareas - **</small></p>
        <p><small> ** - Un tabajador puede ejecutar dos tareas y tener registros en dos secciones del gráfico - **</small></p>
        <p><small>Haga click en una sección del gráfico para ver el detalle</small></p>

          <ngx-charts-pie-chart
            [view]="viewPie"
            [scheme]="colorScheme"
            [results]="datachart4"
            [gradient]="gradientPie"
            [legend]="showLegendPie"
            [legendPosition]="legendPositionPie"
            [labels]="showLabelsPie"
            [trimLabels]="trimLabelsPie" 
            [doughnut]="isDoughnutPie"
            (select)="onSelectSlicePietrabajadores($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)"
            >
          </ngx-charts-pie-chart>
      </div>
      <div class="col" style="text-align: center; background-color: rgb(196, 210, 237);"> 
        <p><strong>Detalle {{detalleActivo}}</strong></p>
        <ngx-charts-bar-horizontal
            [view]="viewDetalle"
            [scheme]="colorScheme"
            [results]="dataDetalleTrabajadores"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [legend]="showLegend"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxisLabel]="xAxisLabelDetalle"
            [yAxisLabel]="yAxisLabelDetalle"
            (select)="onSelectBarTrabajadores($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)">
          </ngx-charts-bar-horizontal>
      </div>  
    </div>   -->

    <div class="row">
      <div class="col" style="text-align: center;"> 
        <p><strong>Trabajos ejecutados por tipo de tarea</strong></p>
        <p><small> ** - No incluye otros tipos de tareas - **</small></p>
        <p><small> ** - Un tabajador puede ejecutar dos tareas y tener registros en dos secciones del gráfico - **</small></p>
        <p><small>Haga click en una sección del gráfico para ver el detalle</small></p>

          <ngx-charts-pie-chart
            [view]="viewPie"
            [scheme]="colorScheme"
            [results]="datachart4"
            [gradient]="gradientPie"
            [legend]="showLegendPie"
            [legendPosition]="legendPositionPie"
            [labels]="showLabelsPie"
            [trimLabels]="trimLabelsPie" 
            [doughnut]="isDoughnutPie"
            (select)="onSelectSlicePietrabajadores($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)"
            >
          </ngx-charts-pie-chart>
      </div>
      <div class="col" style="text-align: center; background-color: rgb(196, 210, 237);"> 
        <p><strong>Detalle {{detalleActivo}}</strong></p>
        <ngx-charts-bar-horizontal
            [view]="viewDetalle"
            [scheme]="colorScheme"
            [results]="dataDetalleTrabajadores"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [legend]="showLegend"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxisLabel]="xAxisLabelDetalle"
            [yAxisLabel]="yAxisLabelDetalle"
            (select)="onSelectBarTrabajadores($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)">
          </ngx-charts-bar-horizontal>
      </div>  
    </div>
    
    <hr>

    <div class="row" style="background-color:rgb(144, 191, 237); padding: 1em;">
      <div class="col" style="text-align: center;"> 
        <h3><strong style="color: whitesmoke;">Dataset</strong> </h3>
          <p>
            <button class="btn btn-primary" (click)="generaexcel()"> Descargar en Excel</button>
          </p>
        <table style="background-color: rgb(47, 119, 192); color: whitesmoke;">
          <thead>
            <tr>
              <th><strong>Empresa</strong></th>
              <th><strong>Trabajadores</strong></th>
              <th><strong>Total PTWs</strong></th>
              <td><strong>alturas</strong></td>
              <td><strong>energias</strong></td>
              <td><strong>hazmat</strong></td>
              <td><strong>confinados</strong></td>
              <td><strong>levantamiento</strong></td>
              <td><strong>calientes</strong></td>
              <td><strong>supervision</strong></td>
              <td><strong>otros</strong></td>
              <!-- <td><strong></strong>tkts</td> -->
            </tr>
          </thead>
          <tbody>

            <tr *ngFor="let item of dataset; let i = index">
              <td>{{item.empresa}}</td>
              <td>{{item.totalTrabajadores}}</td>
              <td>{{item.totalPTWS}}</td>
              <td>{{item.alturas}}</td>
              <td>{{item.energias}}</td>
              <td>{{item.hazmat}}</td>
              <td>{{item.confinados}}</td>
              <td>{{item.levantamiento}}</td>
              <td>{{item.calientes}}</td>
              <td>{{item.supervision}}</td>
              <td>{{item.otros}}</td>
              <!-- <td>{{item.tickets}}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </div>  


  </div>




